import { Link } from 'react-router-dom'
import { Menu } from 'lucide-react'
import { useState } from 'react'
import Navigation from './Navigation'
import ThemeToggle from '@/components/shared/ThemeToggle'
import { Separator } from '@brent/core-ui/ui'
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '@brent/core-ui/ui'
import { Button } from '@brent/core-ui/ui'

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <header className="border-b">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Mobile Menu Button */}
          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
            <SheetTrigger asChild className="md:hidden">
              <Button variant="ghost" size="icon" className="h-10 w-10">
                <Menu className="h-5 w-5" />
                <span className="sr-only">Toggle menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="w-64">
              <SheetTitle className="sr-only">Navigation Menu</SheetTitle>
              <div className="flex flex-col space-y-4 mt-4">
                <Navigation mobile onNavigate={() => setMobileMenuOpen(false)} />
              </div>
            </SheetContent>
          </Sheet>

          {/* Logo and Title */}
          <Link
            to="/"
            className="flex items-center gap-2 sm:gap-3 hover:opacity-80 transition-opacity"
          >
            <img
              src="/images/BSO%20Logo%20Black.svg"
              alt="BSO Logo"
              className="h-8 sm:h-10 dark:invert"
            />
            <h1 className="text-lg sm:text-xl font-bold">Member Portal</h1>
          </Link>

          {/* Desktop Navigation and Theme Toggle */}
          <div className="flex items-center gap-4">
            <div className="hidden md:flex items-center gap-4">
              <Navigation />
              <Separator orientation="vertical" className="h-8" />
            </div>
            <ThemeToggle />
          </div>
        </div>
      </div>
    </header>
  )
}
